import { Component, signal, Signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-accord-form',
  standalone: true,
  imports: [MatButtonModule,MatDialogModule],
  templateUrl: './accord-form.component.html',
  styleUrl: './accord-form.component.scss'
})
export class AccordFormComponent {
  isFormUploaded = signal(false);
  showUploadCard = signal<boolean>(true);
  selectedFile = signal<File | null>(null);
  isDragOver = signal<boolean>(false);
  onUploadErrorMessage = signal<string | null>('');

  constructor(private dialogRef: MatDialogRef<AccordFormComponent>, private router: Router) {}
    
  onFormUpload() {
    this.isFormUploaded.set(true); 
  }

  onSaveExit() {
    this.dialogRef.close('save'); 
  }

  onExit() {
    this.dialogRef.close('exit'); 
  }

  onCancel() {
    this.dialogRef.close();
  }

  RequestQuote(){
    this.dialogRef.close();
    sessionStorage.setItem('quoteType', "indication");
    this.router.navigate(['/request-quote'])
  }

  
}
